
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'date-range',
        field: 'created_at',
        label: 'Data de Cadastro',
        clearable: true,
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'select-tipo',
        field: 'id_tipo_aso',
        label: 'Tipo de ASO',
        clearable: true,
        multiple: true,
        tipo: 46,
        rules: ['']
    },
];



// WEBPACK FOOTER //
// ./src/components/apps/empresa/liberacao/_form/consulta-filtro.js